"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MAX_COMPETENCY_LEVELS", {
    enumerable: true,
    get: function() {
        return MAX_COMPETENCY_LEVELS;
    }
});
const MAX_COMPETENCY_LEVELS = 5;
